import React from 'react';

const paths = {
  grid: 'M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z',
  calendar: 'M4 5h16v16H4z M8 3v4 M16 3v4 M4 10h16 M8 14h2 M14 14h2 M8 17h2',
  recruitment: 'M10 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8 M3 21v-2a5 5 0 0 1 5-5h4 M19 14v6 M16 17h6',
  people: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8 M18 8a3 3 0 0 1 0 6 M22 21v-2a4 4 0 0 0-3-3.87',
  chart: 'M4 3v18h17 M9 16v-5 M14 16V7 M19 16v-9',
  requests: 'M8 3h8v4H8z M8 5H5v16h14V5h-3 M8 12h8 M8 16h5',
  settings: 'M4 7h16 M4 17h16 M8 4v6 M16 14v6',
  chevron: 'm8 10 4 4 4-4',
  plus: 'M12 5v14 M5 12h14',
  download: 'M12 3v12 m-4-4 4 4 4-4 M4 16v5h16v-5',
  search: 'M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15 M16 16l5 5',
  arrow: 'M19 12H5 m6-6-6 6 6 6',
  logout: 'M9 4H4v16h5 M10 12h11 m-5-5 5 5-5 5',
  menu: 'M4 6h16 M4 12h16 M4 18h16',
  close: 'm6 6 12 12 M6 18 18 6',
  chat: 'M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5z'
};

export default function Icon({ name, size = 18, ...props }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true' {...props}>
      <path d={paths[name] || paths.grid} />
    </svg>
  );
}
